module.exports = __webpack_public_path__ + "public/img/bg_di.2a8df656.png";